import { Content } from 'src/app/models/content.model';

export const FAQ1: Content = new Content({
    idContent: 'ee5f7c711be4409a6ac3207c0bf9e5ce',
    order: 1,
    title: '¿Existe algún periodo en el año en el cual se tenga que iniciar el proceso de certificación?',
    content: 'No, los centros de trabajo pueden iniciar su proceso en el momento en el que decidan, ya que la convocatoria se encuentra abierta permanentemente.',
    subContents: []
});
